import { defineMessages } from 'react-intl'

export default defineMessages({
  back: {
    id: 'Back',
    defaultMessage: 'Back'
  },
  deleteConfirm: {
    id: 'SpaceNotificationSourcePage.ConfirmDelete',
    defaultMessage: 'Are you sure you wish to delete {notificationSource}?'
  },
  errorTitle: {
    id: 'UnrecoverableError.Title',
    defaultMessage: 'Something went wrong...'
  },
  errorMessage: {
    id: 'UnrecoverableError.Message',
    defaultMessage: "It's not you, it's us. There was a problem with the system which caused your request to fail."
  },
  title: {
    id: 'NotificationSources',
    defaultMessage: 'Notification Sources'
  }
})
